import { INotificator, TypeObject } from "./INotificator";

//This is dependent on bootstrap4-notify or bootstrap-notify (bootstrap-notify v3.1.3) and JQUERY

//Inpulse4Utilities.Admin\Scripts\Default\typescripts\BootstrapNotificator.ts



/*
 * Class for creating boostrap-notify messages
 * Pass NotifyMessage object with desired values for
 * directing "showMessage" - function.
*/

export class BootstrapNotificator implements INotificator {

    typeList: Array<string> = ["info", "success", "warning", "danger"];
    placementFromArray: Array<string> = ["top", "bottom"];
    placementAlignArray: Array<string> = ["left", "center", "right"];

    typeDefaults = new Array<TypeObject>();

    constructor() {
        // Setting defaults (top-right) which can be overridden by using "defaults" - function.
        for (var i = 0; i < this.typeList.length; i++) {
            var type = this.typeList[i];

            var typeObject = {
                notificationtype: type,
                placementFrom: "top",
                placementAlign: "right",
                duration: 5,
                removeExistingNotifications: false
            };
            this.addDefaultObject(typeObject);
        }
    }

    // Bootstrap notify is not supporting defaults by type. With wrapper you can set defaults for info, success, warning & danger.
    // With this you can set your own defaults per type.
    // Parameter initData = array of typeobjects.
    addDefaultObject(object: TypeObject) {
        this.typeDefaults.push(object);
    }

    setDefaults(initData: Array<TypeObject>) {
        for (var j = 0; j < initData.length; j++) {
            var entry = initData[j];
            var typeIsValid = this.typeDefaults.filter(o => o.notificationtype == entry.notificationtype);
            if (!typeIsValid) {
                console.error("Unrecognized type given: " + entry.notificationtype + " Could not set defaults for this type.");
                return;
            }
            for (var i = 0; i < this.typeDefaults.length; i++) {
                if (this.typeDefaults[i].notificationtype === entry.notificationtype) {

                    if (entry.placementFrom) {
                        if (this.placementFromArray.indexOf(entry.placementFrom) > -1) {
                            this.typeDefaults[i].placementFrom = entry.placementFrom;
                        }
                        else {
                            console.error("Unrecognized placementFrom value given: " + entry.placementFrom + " Could not set this value. Using default!");
                        }
                    }

                    if (entry.placementAlign) {
                        if (this.placementAlignArray.indexOf(entry.placementAlign) > -1) {
                            this.typeDefaults[i].placementAlign = entry.placementAlign;
                        }
                        else {
                            console.error("Unrecognized placementAlign value given: " + entry.placementAlign + " Could not set this value. Using default!");
                        }
                    }

                    if (entry.duration || entry.duration == 0) {
                        if (!isNaN(entry.duration) && isFinite(entry.duration)) {
                            this.typeDefaults[i].duration = entry.duration;
                        }
                        else {
                            console.error("Unrecognized duration value given: " + entry.duration + " Is not valid numeric value. Could not set this value. Using default!");
                        }
                    }

                    // When null / undefined - checking this, we need to allow false values also. Because the given (valid) value is a boolean.
                    if (entry.removeExistingNotifications || entry.removeExistingNotifications === false) {
                        if (typeof (entry.removeExistingNotifications) === "boolean") {
                            this.typeDefaults[i].removeExistingNotifications = entry.removeExistingNotifications;
                        } else {
                            console.error("Unrecognized removeExistingNotifications value given: " + entry.removeExistingNotifications + " Is not valid boolean value. Could not set this value. Using default!");
                        }
                    }
                }
            }
        }
    }

    // @messages Array<string> messages to be shown
    // @msgParams {object} default or set values can be overwritten
    showMessages(messages: Array<string>, msgParams: TypeObject) {
        var defaultValues: Array<TypeObject>;

        if (!messages) {
            return;
        }

        if (!msgParams) {
            msgParams = {
                notificationtype: "info"
            };
        }

        // Get defaults if available.
        if (msgParams.notificationtype) {
            defaultValues = this.typeDefaults.filter(o => o.notificationtype == msgParams.notificationtype);
        } else {
            // No type given as a parameter. Using the preferred default (which is info).
            defaultValues = this.typeDefaults.filter(o => o.notificationtype == "info");
        }

        // Use the given values or defaults.
        msgParams.notificationtype = msgParams.notificationtype || defaultValues[0].notificationtype;  //"info";
        msgParams.placementFrom = msgParams.placementFrom || defaultValues[0].placementFrom; // "top";
        msgParams.placementAlign = msgParams.placementAlign || defaultValues[0].placementAlign;  //"right";
        msgParams.duration = msgParams.duration || defaultValues[0].duration;
        msgParams.removeExistingNotifications = msgParams.removeExistingNotifications || defaultValues[0].removeExistingNotifications;

        // Convert to milliseconds.
        if (msgParams.duration && msgParams.duration != 0) {
            msgParams.duration = msgParams.duration * 1000;
        }
        //persistent message: duration = -1
        if (msgParams.duration && msgParams.duration == -1) {
            msgParams.duration = 0;
        }

        // Set icon and title.
        if (msgParams.notificationtype === "danger") {
            msgParams.icon = "fa fa-exclamation-triangle fa-2";
            msgParams.title = "HUOM!";
        }
        else if (msgParams.notificationtype === "warning") {
            msgParams.icon = "fa fa fa-flag fa-2";
            msgParams.title = "HUOM!";
        }
        else if (msgParams.notificationtype === "success") {
            msgParams.icon = "fa fa-thumbs-o-up fa-2";
            msgParams.title = "";
        }

        if (msgParams.removeExistingNotifications) {
            $(".alert-" + msgParams.notificationtype).remove();
        }

        for (var i = 0; i < messages.length; i++) {
            var msg = messages[i];
            $.notify({
                icon: msgParams.icon,
                title: msgParams.title,
                message: msg
            }, {
                type: msgParams.notificationtype,
                delay: msgParams.duration,
                icon_type: "class",
                placement: {
                    from: msgParams.placementFrom,
                    align: msgParams.placementAlign
                },
                z_index: 1200
            });
        }
    }

    //few helper methods for common types
    showMessage(message: string) {
        this.showMessages([message], null);
    }

    showInfoMessage(message: string) {
        var parameters = {
            notificationtype: "info"
        };
        this.showMessages([message], parameters);
    }

    showWarningMessage(message: string) {
        var parameters = {
            notificationtype: "warning"
        };
        this.showMessages([message], parameters);
    }
    showDangerMessage(message: string) {
        var parameters = {
            notificationtype: "danger"
        };
        this.showMessages([message], parameters);
    }

    showSuccessMessage(message: string) {
        var parameters = {
            notificationtype: "success"
        };
        this.showMessages([message], parameters);
    }

    showDangerMessagePersistant(message: string) {
        var parameters = {
            notificationtype: "danger",
            duration: -1
        };
        this.showMessages([message], parameters);
    }

    showDangerMessagePersistantRemoveExistingNotifications(message: string) {
        var parameters = {
            notificationtype: "danger",
            duration: -1,
            removeExistingNotifications: true
        };
        this.showMessages([message], parameters);
    }
}